var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 27 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5.333c-4.595 0-8.333 3.738-8.333 8.333v5H3.5A3.337 3.337 0 0 0 .167 17v13.333A3.337 3.337 0 0 0 3.5 33.666h20a3.337 3.337 0 0 0 3.333-3.333V17a3.337 3.337 0 0 0-3.333-3.334h-15v-5c0-2.756 2.243-5 5-5s5 2.244 5 5V10h3.333V8.666c0-4.595-3.738-8.333-8.333-8.333M23.5 17l.003 13.333H3.5V17z"
  })));
};
export default SvgUnlock;